import React, { useEffect, useState } from 'react';
import {connect} from 'react-redux'
import {
    AppBar,
    Card,
    CardContent,
    Toolbar,
    Typography
} from '@material-ui/core';
import {withRouter} from "react-router-dom";
import UecareLightBox from "./UecareLightBox";
import PatientChiefComplaint from "./PatientChiefComplaint";
import GcsFileService from '../service/gcsFile';

const MissionInfoTab = ({
    mission,
}) => {
    const [healthCareImage, setHealthCareImage] = useState()

    useEffect(() => {
        if (!mission) return
        (async () => {
            console.log(mission)
            const { personal } = await GcsFileService.getDownloadUrlByMission(mission.id);
            const file = personal[0];
            if (file) {
                const image = await fetch(file.url).then((r) => r.text());
                setHealthCareImage(image);
            }
        })()
    }, [mission])

    let healthCareLightBox
    let imageLightBox

    const getMissionImages = mission => {
        const types = ['consult_mission', 'reservation_mission', 'specialist_mission'];
        const currentType = types.find((type) => {
            return mission[type];
        });

        const images = (currentType) ? mission[currentType].images : [];
        return (images || []).map((image) => {
            return {...image, src: image.url};
        });
    }

    const renderGallery = (images=[], type) => {
        const gallery = images.map((obj, i) => {
            return (
                <a
                    href={obj.src}
                    key={i}
                    onClick={(e) => {
                        if (type === 'healthCare') healthCareLightBox.openLightbox(i, e)
                        else imageLightBox.openLightbox(i, e)
                    }}
                >
                    <img className="w-128 h-128 p-8" alt='' src={obj.src}/>
                </a>
            );
        });
        return gallery;
    }

    const {
        vip_note,
        mission_score,
        mission_feedback,
        medicalReport: report,
        medicalSuggest: suggest,
    } = mission
    const images = getMissionImages(mission)

    return (
        <div>
            <Card className="w-full mb-16">
                <AppBar position="static" elevation={0}>
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            問題描述
                        </Typography>
                    </Toolbar>
                </AppBar>

                <CardContent>
                    <div className="mb-24">
                        <PatientChiefComplaint mission={mission} />
                    </div>
                </CardContent>
            </Card>
            <Card className='w-full mb-16'>
            <AppBar position="static" elevation={0} color="secondary">
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            健保卡
                        </Typography>
                    </Toolbar>
                </AppBar>

                <CardContent>
                    <div className="mb-24">
                        {healthCareImage && (<div>
                            <UecareLightBox images={[{src: healthCareImage}]} ref={ref => healthCareLightBox = ref}/>
                            {renderGallery([{src: healthCareImage}], 'healthCare')}
                        </div>)}
                    </div>
                </CardContent>
            </Card>
            <Card className="w-full mb-16">
                <AppBar position="static" elevation={0}>
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            相片
                        </Typography>
                    </Toolbar>
                </AppBar>

                <CardContent>
                    <div className="mb-24">
                        <UecareLightBox images={images} ref={ref => imageLightBox = ref}/>
                        {renderGallery(images)}
                    </div>
                </CardContent>
            </Card>
            <Card className="w-full mb-16">
                <AppBar position="static" elevation={0} color="secondary">
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            醫師建議
                        </Typography>
                    </Toolbar>
                </AppBar>

                <CardContent>
                    <div className="mb-24">
                        <Typography>{suggest ? `${suggest.suggestion}：${suggest.detail}` : '（無）'}</Typography>
                        {suggest && suggest.coop_reply
                        && <Typography>
                            {suggest.coop_reply}
                        </Typography>
                        }
                    </div>
                </CardContent>
            </Card>
            <Card className="w-full mb-16">
                <AppBar position="static" elevation={0}>
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            醫師交班
                        </Typography>
                    </Toolbar>
                </AppBar>

                <CardContent>
                    <div className="mb-24">
                        <div className="mb-16">
                            <Typography>疾病描述：{report ? report.medical_ill_description : '（無）'}</Typography>
                            <Typography>結論：{report ? report.conclusion : '（無）'}</Typography>
                        </div>

                        <div>
                            <Typography>主訴/徵候 (Subjective)：{report ? report.subjective : '（無）'}</Typography>
                            <Typography>診察/發現（Objective)：{report ? report.objective : '（無）'}</Typography>
                            <Typography>評估/診斷（Assessment)：{report ? report.assessment : '（無）'}</Typography>
                            <Typography>建議/處置（Plan)：{report ? report.plan : '（無）'}</Typography>
                        </div>
                    </div>
                </CardContent>
            </Card>
            <Card className="w-full mb-16">
                <AppBar position="static" elevation={0} color="secondary">
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            會員回饋
                        </Typography>
                    </Toolbar>
                </AppBar>

                <CardContent>
                    <div className="mb-24">
                        <Typography>{mission_score ? `${mission_score} 顆星 ${mission_feedback}` : '（無）'}</Typography>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}

function mapStateToProps({ mission: { temp: tempMission } }) {
    return { mission: tempMission }
}

export default withRouter(connect(mapStateToProps, null)(MissionInfoTab));



// WEBPACK FOOTER //
// ./src/components/MissionInfoTab.js